import React from "react";
import { Shield, Award } from "lucide-react";

const TIER_CONFIG = {
  premium: {
    label: "Premium",
    icon: Shield,
    className: "bg-amber-500/15 text-amber-400 border border-amber-500/30"
  },
  invited: {
    label: "Premium",
    icon: Shield,
    className: "bg-amber-500/15 text-amber-400 border border-amber-500/30"
  },
  top: {
    label: "Premium",
    icon: Shield,
    className: "bg-amber-500/15 text-amber-400 border border-amber-500/30"
  },
  regular: {
    label: null,
    icon: null,
    className: ""
  }
};

export default function ExpertTierBadge({ tier, size = "md" }) {
  const config = TIER_CONFIG[tier] || TIER_CONFIG.regular;
  if (!config.label) return null;

  const Icon = config.icon;
  const sizeClasses = size === "lg"
    ? "px-4 py-1.5 text-lg gap-2"
    : "px-3 py-1 text-lg gap-1.5";

  return (
    <span
      id={`expert-tier-badge_${tier}`}
      className={`inline-flex items-center font-extralight rounded-md ${config.className} ${sizeClasses}`}
    >
      <Icon className={size === "lg" ? "w-4 h-4" : "w-3.5 h-3.5"} />
      {config.label}
    </span>
  );
}
